import axios from 'axios';
import { ElMessage } from 'element-plus';
import qs from 'qs'

let config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }
}

let configJson = {
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
}

let configImg = {
  headers: {
    'Content-Type': 'multipart/form-data; charset=UTF-8'
  }
}

export const postFormData = (url,params) => { return axios.post(HOST+url, qs.stringify(params), config).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };

export const getFormData = (url,params) => { return axios.get(HOST+url, { params: params }, config).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };

export const patchFormData = (url,params) => { return axios.patch(HOST+url, qs.stringify(params), config).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };

export const deleteFormData = (url,params) => { return axios.delete(HOST+url, { data: params }, configJson).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };

export const imgFormData = (url,params) => { return axios.post(HOST+url, params, configImg).then(res => res.data); };

export const imgPutFormData = (url,params) => { return axios.put(HOST+url, params, configImg).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };

export const imgPatchFormData = (url,params) => { return axios.patch(HOST+url, params, configImg).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };

export const imgPostFormData = (url,params) => { return axios.post(HOST+url, params, configImg).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };


export const patchJson = (url,params) => { return axios.patch(HOST+url, JSON.stringify(params), configJson).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };

export const postJson = (url,params) => { return axios.post(HOST+url, JSON.stringify(params), configJson).then(res => {
  let code = res.data.code;
  if(code == 407) {
    window.location.href = "/";
  }
  return res.data;
}).catch(function(response) {
  ElMessage({
    showClose: true,
    duration: 1000,
    message: "请求失败",
    type: 'error'
  });
}); };
